import { FC, useCallback } from 'react';
import { audioCallLocalStream } from 'services/voip';

import MeetingAction from '../MeetingAction';

interface IProps {
  isEnabled: boolean;
  onChange(value: boolean): void;
}

const MicrophoneButton: FC<IProps> = ({ isEnabled, onChange }) => {
  const onToggleAudio = useCallback(() => {
    const value = !isEnabled;

    audioCallLocalStream.current?.getAudioTracks().forEach(track => {
      track.enabled = value;
    });

    onChange(value);
  }, [isEnabled, onChange]);

  return (
    <MeetingAction
      isSelected={!isEnabled}
      icon={isEnabled ? 'microphone' : 'microphoneMuted'}
      onClick={onToggleAudio}
    />
  );
};

export default MicrophoneButton;
